import { getImpersonatedUserId } from "hooks/useImpersonation/useImpersonation";

// One sentence for the client-side guard and for the server's refusal, so there
// is one string to translate and one string to assert.
export const IMPERSONATION_BLOCK_MESSAGE =
  "You are acting as another teacher. Stop acting as them before joining a session.";

export const IMPERSONATION_ERROR_CODE = "IMPERSONATION_ACTIVE";

export const isActingAsAnotherTeacher = () => getImpersonatedUserId() !== null;

export const impersonationBlockError = () => {
  const error = new Error(IMPERSONATION_BLOCK_MESSAGE);
  error.detail = {
    error_code: IMPERSONATION_ERROR_CODE,
    message: IMPERSONATION_BLOCK_MESSAGE,
  };
  return error;
};
